<template>
  <div class="bncc-wrap">
    <div class="product-pic">
      <img :src="bncc.pic" alt />
    </div>
    <div class="product-info">
      <div class="product-name">{{ bncc.strainDesignations }}</div>

    </div>
    <div class="product-detail">
      <div class="title">商品详情</div>
      <div class="content">
        <table border="1" cellspacing="0" cellpadding="0.267rem">
          <thead>
            <tr>
              <th colspan="2">基本信息</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="name">资源编号</td>
              <td>{{ bncc.bnccid }}</td>
            </tr>
            <tr>
              <td class="name">中文名称</td>
              <td>{{ bncc.strainDesignations }}</td>
            </tr>

            <tr v-if="bncc.otherNo">
              <td class="name">其它编号</td>
              <td>{{ bncc.otherNo }}</td>
            </tr>

            <tr v-if="bncc.speciesGenus">
              <td class="name">种属</td>
              <td>{{ bncc.speciesGenus }}</td>
            </tr>

            <tr v-if="bncc.cellType">
              <td class="name">类型</td>
              <td>{{ bncc.cellType }}</td>
            </tr>

            <tr v-if="bncc.morphology">
              <td class="name">形态</td>
              <td>{{ bncc.morphology }}</td>
            </tr>

            <tr v-if="bncc.isolation">
              <td class="name">分离基物</td>
              <td>{{ bncc.isolation }}</td>
            </tr>

            <tr v-if="bncc.productFormat">
              <td class="name">提供形式</td>
              <td>{{ bncc.productFormat }}</td>
            </tr>

            <tr v-if="bncc.biosafetyLevel">
              <td class="name">安全等级</td>
              <td>{{bncc.biosafetyLevel}}</td>
            </tr>

            <tr v-if="bncc.typeStrain">
              <td class="name">模式菌株</td>
              <td>{{ bncc.typeStrain }}</td>
            </tr>

            <tr v-if="bncc.application">
              <td class="name">应用领域</td>
              <td>{{ bncc.application }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="title" style="margin-top: 1.067rem">培养方法</div>
      <div class="content">
        <table border="1" cellspacing="0" cellpadding="0.267rem">
          <thead style="background-color: #5f5f5f; border-color: #5f5f5f">
            <tr>
              <th colspan="3">培养方法</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="bncc.medium">
              <td class="name">培养基</td>
              <td>{{ bncc.medium }}</td>
            </tr>

            <tr v-if="bncc.subculturing">
              <td class="name">传代方法</td>
              <td>{{ bncc.subculturing }}</td>
            </tr>

            <tr v-if="bncc.growthConditions">
              <td class="name">生长条件</td>
              <td>{{ bncc.growthConditions }}</td>
            </tr>

            <tr v-if="bncc.cultureProperties">
              <td class="name">生长特性</td>
              <td>{{ bncc.cultureProperties }}</td>
            </tr>

            <tr v-if="bncc.storageConditions">
              <td class="name">存储条件</td>
              <td>{{ bncc.storageConditions }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <slot-footer
    :pid="id"
    tid="3"
    type="7"
    :isFav="isFav"
  ></slot-footer>
</template>

<script lang="ts">
import { defineComponent, ref, reactive, onMounted } from "vue";
import { useRoute } from "vue-router";
import useFootPrint from "@/hooks/useFootPrint";
import api from "@/api/axios";

import SlotFooter from "@/components/common/SlotFooter.vue";
export default defineComponent({
  name: "bnccdetail",
  components: {
    SlotFooter,
  },
  setup() {
    onMounted(() => {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    });
    const route = useRoute();
    const id = ref(route.params.id);
    const classId = ref(route.params.classId);
    const bncc = ref({});
    const isFav = ref(false);
    //   axios.get("/M/Product").then(res=>{
    //     productsVO.value = res.data.obj;
    //   })
    const comp = ref({});
    const { setFootItem } = useFootPrint();
    api
      .get("/M/Product/BNCCDetail/" + id.value)
      .then((res): void => {
        const data = res.data.obj;
        bncc.value = data.bncc;
        isFav.value = data.isFav;
        setFootItem({
          type: "bncc",
          img: data.bncc.switchBnccUrl,
          title: data.bncc.strainDesignations,
          info: "BNCC" + data.bncc.id,
          id: data.bncc.id,
          brand: data.bncc.speciesGenus,
          summary: data.bncc.bnccid,
          url: { name: "bnccdetail", query: { id: route.params.id, classId: route.params.id } },
        });
      })
      .catch((err) => {
        console.log(err);
      });
    return {
      bncc,
      id,
      isFav,
      comp,
      classId
    };
  },
});
</script>

<style lang="scss" scoped>
.bncc-wrap {
  padding-bottom: 80px;
}
.product-pic img {
    width: 375px;
    height: 375px;
    display: block;
  }
  
  .product-info {
    position: relative;
    padding: 10.013px;
    padding-top: 21.487px;
    width: 100%;
    box-sizing: border-box;
    border-bottom: 6px solid #f4f4f4;
  }
  
  .product-name {
    width: 255px;
    color: #444444;
    font-size: 16.012px;
    position: relative;
    font-weight: bold;
  }
  
  .operation {
    position: absolute;
    right: 10.013px;
    top: 50%;
    transform: translateY(-50%);
  }
  .operation a {
    color: #cc3333;
    font-size: 15px;
    font-weight: 700;
  }
  
  .product-detail .title {
    padding-left: 19.988px;
    font-size: 15px;
    color: #444;
    position: relative;
    width: 375px;
    box-sizing: border-box;
    height: 43.988px;
    line-height: 43.988px;
    border-bottom: 1px solid #f4f4f4;
  }
  .product-detail .title::after {
    content: "";
    position: absolute;
    width: 2px;
    left: 10.013px;
    top: 50%;
    height: 13.012px;
    background-color: #df0024;
    margin-top: -6.487px;
  }
  
  table {
    width: 355.013px;
    border: none;
    margin: 0 auto;
    margin-top: 19.988px;
    border-collapse: collapse;
    border-color: #ccc;
  }
  thead {
    width: 355.013px;
    background-color: #df0024;
    border: 1px solid #df0024;
  }
  th {
    color: #fff;
    text-align: left;
    height: 30px;
    box-sizing: border-box;
    padding: 0 9px;
    line-height: 30px;
    font-size: 13.988px;
  }
  td {
    font-size: 13.988px;
    color: #666666;
    padding: 10.013px;
    word-break: break-word;
  }
  
  .name {
    width: 117px;
    box-sizing: border-box;
    border-right-color: #e5e5e5;
    background-color: #f2f2f2;
    line-height: 25.013px;
  }
  .detail-name {
    width: 49.987px;
    box-sizing: border-box;
  }
  .other-view {
    margin-top: 19.988px;
    border-top: 1px solid #eee;
  }
  .other-view .title {
    text-align: justify;
    font-size: 16.012px;
    color: #666666;
    line-height: 25.013px;
    margin: 19.988px 10.013px;
    font-weight: bold;
  }
  
  .other-view .content .detail-title {
    width: 355.013px;
    margin: 0 auto;
    font-size: 16.012px;
    color: #444;
    position: relative;
  
    margin-top: 19.988px;
    box-sizing: border-box;
  }
  
  .other-view .content .detail-content {
    width: 355.013px;
    margin: 0 auto;
    font-size: 15px;
    color: #444;
    position: relative;
  
    box-sizing: border-box;
  }
  
  .pdt_detail_box {
    font-size: 16.012px;
  
    color: #444;
    width: 375px;
    box-sizing: border-box;
    width: 355.013px;
    margin: 0 auto;
  }
  
  .info-left {
    margin: 0 auto;
    text-align: center;
  }
  
  .productViews {
    width: 109.987px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    background-color: #df0024;
    color: #fff;
    border-radius: 36px;
    margin: 0 auto;
    margin-top: 7.987px;
  }
  
  .other-view .content a {
    text-align: justify;
    font-size: 16.012px;
    line-height: 25.013px;
    display: block;
    color: #666666 !important;
    margin: 12.488px 10.013px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
</style>
